import { motion } from "framer-motion";
import { useLang } from "@/lib/lang";
import { Reveal, Eyebrow, EASE } from "./Reveal";

export const Model = () => {
  const { t } = useLang();
  const m = t.model;
  return (
    <section id="model" className="section bg-surface" data-testid="model-section">
      <div className="container-x">
        <Reveal><Eyebrow>{m.eyebrow}</Eyebrow></Reveal>
        <div className="mt-10 space-y-2">
          {m.nos.map((n, i) => (
            <motion.div key={n} initial="hide" whileInView="show" viewport={{ once: true, amount: 0.1 }} className="overflow-hidden">
              <motion.p variants={{ hide: { y: "100%" }, show: { y: "0%" } }} transition={{ duration: 1, delay: i * 0.12, ease: EASE }} className="relative inline-block font-display text-4xl font-semibold tracking-[-0.03em] text-ink sm:text-6xl lg:text-7xl" data-testid={`model-no-${i}`}>
                {n}
                <motion.span variants={{ hide: { scaleX: 0 }, show: { scaleX: 1 } }} transition={{ duration: 0.8, delay: 0.6 + i * 0.15, ease: EASE }} className="absolute left-0 top-[55%] h-[3px] w-full origin-left bg-gold" />
              </motion.p>
            </motion.div>
          ))}
        </div>
        <div className="mt-20 grid gap-5 md:grid-cols-2">
          <Reveal className="rounded-[24px] bg-gold p-8 text-bg sm:p-12" >
            <p className="font-mono text-xs uppercase tracking-[0.2em]">Success fee</p>
            <p className="mt-6 font-display text-2xl font-medium leading-snug sm:text-3xl" data-testid="model-fee">{m.fee}</p>
          </Reveal>
          <Reveal delay={0.1} className="flex flex-col justify-between rounded-[24px] border border-line p-8 sm:p-12">
            <p className="text-lg text-zinc-300">{m.honest}</p>
            <p className="mt-10 font-display text-2xl text-ink sm:text-3xl">{m.aligned} <span className="font-serif italic text-gold">{m.alignedAccent}</span></p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
